import React, { useEffect } from "react";
import styled from "@emotion/styled";
import NewCard from "@components/NewCard";
import { connect } from "react-redux";
import { defaultAction } from "@actions/defaultAction";

import { SORT_DROP_DOWN, SET_CATEGORY } from "@constants/actionTypes";
import {
  getMerchantArray,
  getCategoryMerchantArray
} from "@modules/NewBuy/selector";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 20px;
  grid-row-gap: 82px;
  margin-top: 67px;
  @media (max-width: 1300px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 925px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 575px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 450px) {
    margin-top: 73px;
  }
`;

const CardRow = ({
  allDiscountedMerchants,
  filterDropDown,
  sortDropdown,
  filterCategory
}) => {
  useEffect(() => {}, [allDiscountedMerchants, filterDropDown]);
  useEffect(() => {
    return () => {
      sortDropdown();
      filterCategory("");
    };
  }, []);
  return (
    <GridContainer className="animated fadeIn">
      {allDiscountedMerchants &&
        allDiscountedMerchants.map((card, index) => (
          <NewCard
            key={index}
            img={card.image}
            brand={card.name}
            slug={card.slug.slice(6, card.slug.length - 6)}
          />
        ))}
    </GridContainer>
  );
};

export default connect(
  state => ({
    selectedCategory: state.userActions.selectedCategory,
    allDiscountedMerchants: !state.userActions.selectedCategory
      ? getMerchantArray({
          merchantArray: state.merchantsNew.sortedByName,
          currentSearch: state.userActions.buySearchText,
          filterCards: state.userActions.filterCards
        })
      : getCategoryMerchantArray({
          merchantArray: state.merchantsNew.sortedByName,
          currentSearch: state.userActions.buySearchText,
          filterCards: state.userActions.filterCards,
          categories: state.categories.allCategories,
          categoryName: state.userActions.selectedCategory
        }),
    filterDropDown: state.userActions.filterDropDown
  }),
  dispatch => ({
    sortDropdown: () => dispatch(defaultAction(SORT_DROP_DOWN, "Most Popular")),
    filterCategory: category => dispatch(defaultAction(SET_CATEGORY, category))
  })
)(CardRow);
